/* eslint-disable no-empty-pattern */
/* eslint no-param-reassign: 0 */
import { VideoService } from '../services/video.service';

const videoState = {
  video: null,
  state: '',
};
const mutations = {
  setVideo(state, video) {
    state.video = video;
    state.state = '';
  },
  setState(state, type) {
    state.state = type;
  },
};
const getters = {
  current: state => state.video,
  state: state => state.state,
};
const actions = {
  getVideo: async ({ commit }, id) => {
    try {
      commit('setState', 'loading');
      const video = await VideoService.getVideo(id);
      commit('setVideo', video);
      return video;
    } catch (e) {
      commit('setState', 'error');
      return false;
    }
  },
  update: async ({ commit }, { id, data }) => {
    try {
      const video = await VideoService.updateVideo(id, data);
      commit('setVideo', video);
      return true;
    } catch (e) {
      return false;
    }
  },
  uploadPoster: async ({}, { id, file }) => {
    try {
      const poster = await VideoService.uploadPoster(id, file);
      return poster;
    } catch (e) {
      return false;
    }
  },
  delete: async ({}, id) => {
    try {
      await VideoService.deleteVideo(id);
      return true;
    } catch (e) {
      return false;
    }
  },
};

export default {
  namespaced: true,
  state: videoState,
  mutations,
  getters,
  actions,
};
